export function append<TSource, TNew extends TSource>(
  array: TSource[],
  item: TNew,
) {
  return [...array, item];
}
